import { Fragment } from 'react'
import { translateManager as t } from '../../../services/TranslateManager'
import { formatPriceWithPrecision } from '../../../utils/utils'
import SkeletonRow from '../../SkeletonRow/SkeletonRow'
import SingleCouponSection from './SingleCouponSection'
import And from './And'

function GiftCardSection({ giftCardCredits, pricingData }) {
  if (giftCardCredits.length === 0) return null

  return (
    <>
      {giftCardCredits.map(({ code, balance, initialValue }) => (
        <Fragment key={code}>
          <SingleCouponSection
            headerTitle={t.get('general.menu.gift_card')}
            title={code}
            subtitle={
              initialValue && !isNaN(balance) && pricingData.currency ? (
                t.get('general.promo_code_selector.gift_card_description', {
                  v1: formatPriceWithPrecision(
                    initialValue,
                    pricingData.currency
                  ),
                  v2: formatPriceWithPrecision(balance, pricingData.currency),
                })
              ) : (
                <SkeletonRow width={50} height={15} />
              )
            }
          />
          <And />
        </Fragment>
      ))}
    </>
  )
}

export default GiftCardSection
